import { useState, useEffect, useRef, RefObject } from 'react';

type Size = {
    width: number;
    height: number;
};

function useElementSize<T extends HTMLElement>(): [RefObject<T | null>, Size] {
    const ref = useRef<T>(null);
    const [size, setSize] = useState<Size>({ width: 0, height: 0 });

    useEffect(() => {
        if (!ref.current) return;

        const updateSize = () => {
            if (ref.current) {
                setSize({
                    width: ref.current.offsetWidth,
                    height: ref.current.offsetHeight
                });
            }
        };

        updateSize(); // Set initial size

        const resizeObserver = new ResizeObserver(() => {
            updateSize();
        });

        resizeObserver.observe(ref.current);

        // Cleanup function to disconnect the observer on unmount
        return () => {
            resizeObserver.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref.current]);

    return [ref, size];
}

export default useElementSize;
